import type React from 'react'
import { cn } from '../../../shared/cn'

export function H4({ className, ...props }: React.ComponentPropsWithoutRef<'h3'>) {
  return (
    <h4
      data-slot='heading'
      {...props}
      className={cn('font-semibold text-base text-contentPrimary leading-5', className)}
    />
  )
}
